import React from 'react';
import { FadeIn } from '../ui/FadeIn';
import { Piano, HandMetal, Combine, Music2 } from 'lucide-react';
export function Results() {
  const results = [{
    icon: <Piano className="w-6 h-6" data-id="element-216" />,
    text: 'Reconocer el teclado sin esfuerzo'
  }, {
    icon: <HandMetal className="w-6 h-6" data-id="element-217" />,
    text: 'Tocar acordes básicos'
  }, {
    icon: <Combine className="w-6 h-6" data-id="element-218" />,
    text: 'Coordinar ambas manos'
  }, {
    icon: <Music2 className="w-6 h-6" data-id="element-219" />,
    text: 'Tocar canciones completas'
  }];
  return <section className="py-16 md:py-20 bg-navy-light relative overflow-hidden" data-id="element-220">
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[600px] h-[300px] bg-gold/5 rounded-full blur-3xl pointer-events-none" data-id="element-221"></div>

      <div className="container mx-auto px-4 max-w-5xl relative z-10" data-id="element-222">
        <FadeIn data-id="element-223">
          <h2 className="text-3xl md:text-4xl font-black text-center text-beige mb-3" data-id="element-224">
            Lo que vas a <span className="text-gold" data-id="element-225">lograr</span>
          </h2>
          <p className="text-center text-beige/60 mb-12 text-lg" data-id="element-226">
            Con este método paso a paso
          </p>
        </FadeIn>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-4" data-id="element-227">
          {results.map((result, index) => <FadeIn key={index} delay={index * 0.08} data-id="element-228">
              <div className="bg-navy-lighter border border-gold/20 rounded-2xl p-5 flex flex-col items-center text-center gap-4 hover:border-gold/40 transition-all duration-300 h-full" data-id="element-229">
                <div className="w-14 h-14 rounded-full bg-gold/15 text-gold flex items-center justify-center" data-id="element-230">
                  {result.icon}
                </div>
                <p className="text-base font-semibold text-beige leading-tight" data-id="element-231">
                  {result.text}
                </p>
              </div>
            </FadeIn>)}
        </div>

        <FadeIn delay={0.4} data-id="element-232">
          <p className="text-center text-base md:text-lg text-beige/60 mt-10 italic max-w-2xl mx-auto" data-id="element-233">
            "Disfrutá tocar piano sin presión, a tu ritmo y desde tu casa"
          </p>
        </FadeIn>
      </div>
    </section>;
}